import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FormGroup, FormBuilder, FormArray } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { DialogService } from '../../_services/dialog.service';
import { Cue5050DetailView } from '../../_models/fundraising/Cue5050';
import { Cue5050Service } from '../../_services/fundraising/cue5050.service';
import { CurrencyPipe, DatePipe } from '@angular/common';

@Component({
    templateUrl: './event-details-modal.component.html',
    styleUrls: ['./event-details-modal.component.css']
  })

export class EventDetailsModalComponent implements OnInit {

    public loading = false;
    public cue5050Id: number;

    public form: FormGroup;

    public viewRef: ViewContainerRef;

    constructor(
        private bsModalRef: BsModalRef,
        private fb: FormBuilder,
        private spinner: NgxSpinnerService,
        private dialogService: DialogService,
        private cue5050Service: Cue5050Service,
        private currencyPipe: CurrencyPipe,
        private datePipe: DatePipe
      ) { }

    ngOnInit(){
      this.loading = true;
      this.spinner.show();
      this.cue5050Service.getEventDetails(this.cue5050Id)
        .subscribe(details => {
          this.loading = false;
          this.spinner.hide();
          this.initForm(details);
        }, error => {
          this.loading = false;
          this.spinner.hide();
          this.close();
          this.dialogService.alert('Uh oh!', 'Something went wrong trying to get details for that event.', this.viewRef);
        })
    }

    initForm(cue5050Details: Cue5050DetailView){
        this.form = this.fb.group({
          eventName: [cue5050Details.eventName],
          eventCoordinator: [cue5050Details.eventCoordinator],
          beneficiary: [cue5050Details.beneficiary],
          startDate: [this.datePipe.transform(cue5050Details.startDate, 'MM-dd-yyyy')],
          endDate: [this.datePipe.transform(cue5050Details.endDate, 'MM-dd-yyyy')],
          grossSales: [this.currencyPipe.transform(cue5050Details.grossSales / 100)],
          cueFees: [this.currencyPipe.transform(cue5050Details.cueFees / 100)],
          expenses: [this.currencyPipe.transform(cue5050Details.expenses / 100)],
          cardFees: [this.currencyPipe.transform(cue5050Details.cardFees / 100)],
          totalPot: [this.currencyPipe.transform(cue5050Details.totalPot / 100)],
          prizeTotal: [this.currencyPipe.transform(cue5050Details.prizeTotal / 100)],
          payouts: [cue5050Details.payouts.map(p => { 
            return {
              amount: p?.amount ? this.currencyPipe.transform(p?.amount / 100) : 'N/A',
              arrivalDate: p?.arrivalDate ? this.datePipe.transform(p?.arrivalDate, 'MM-dd-yyyy') : 'N/A',
              description: p?.description ?? 'N/A',
              type: p?.type ?? 'N/A',
              status: p?.status ?? 'N/A'
            }
          })]
        });
        
        this.form.disable();





    }

    close() {
      this.bsModalRef.hide();
    }
}